import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { NgClass, NgIf } from '@angular/common'
import { ProfileModel } from '../../../core/models/profile.model'
import { animate, state, style, transition, trigger } from '@angular/animations'
import { PermissionService } from '../../../core/services/permission/permission.service'
import { SnackbarCustomService } from '../snackbar/snackbar-custom.service'

interface Acao {
  id_crud: number
  descricao: string
  tem_permissao: number
}

interface ModuloPermissao {
  id_modulo: number
  modulo: string
  acoes: Acao[]
}

@Component({
  selector: 'table-list-permission',
  imports: [MatTableModule, MatIcon, NgClass, NgIf],
  templateUrl: './table-list-permission.component.html',
  styleUrl: './table-list-permission.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [PermissionService],
})
export class TableListPermissionComponent implements OnInit, OnChanges {
  constructor(
    private permissionService: PermissionService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Input() dataSource: ModuloPermissao[] = []
  @Input() columns: any[] = []
  @Input() profile: ProfileModel = new ProfileModel()
  @Output() refreshList = new EventEmitter()

  displayedColumns: string[] = ['modulo', 'total_acoes', 'status_modulo', 'expand']
  tableSource: MatTableDataSource<ModuloPermissao> = new MatTableDataSource()
  expandedElement: ModuloPermissao | null = null

  ngOnInit() {
    this.tableSource = new MatTableDataSource<ModuloPermissao>(this.dataSource)
  }

  ngOnChanges(changes: any) {
    if (changes['dataSource']) {
      this.updateTableDataSource()
    }
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource || []
    this.tableSource._updateChangeSubscription()
  }

  updatePermission(acao: Acao, modulo: ModuloPermissao) {
    const model = {
      perfil_id: this.profile.id,
      modulo_id: modulo.id_modulo,
      id_crud: acao.id_crud,
    }
    const model_multiplos = {
      perfil_id: this.profile.id,
      modulo_id: modulo.id_modulo,
      id_cruds: [acao.id_crud],
    }
    // Se tem_permissao === 1, então está permitido e deve revogar
    // Se tem_permissao === 0, então não está permitido e deve conceder
    const action =
      acao.tem_permissao === 1
        ? this.permissionService.unassignProfilePermission(model_multiplos)
        : this.permissionService.assignProfilePermission(model)

    action.subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.refreshList.emit(true)
      },
      error: (err: any) => {
        this.snackbar.errorRequest(err)
      },
    })
  }

  updateModulePermission(modulo: ModuloPermissao) {
    const todasPermitidas = modulo.acoes.every(acao => acao.tem_permissao === 1)

    const model = {
      perfil_id: this.profile.id,
      modulo_id: modulo.id_modulo,
    }

    // Se todas estão permitidas, revoga o módulo inteiro
    // Se alguma não está permitida, concede o módulo inteiro
    const action = todasPermitidas
      ? this.permissionService.unassignModulePermission(model)
      : this.permissionService.assignModulePermission(model)

    action.subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.refreshList.emit(true)
      },
      error: (err: any) => {
        this.snackbar.errorRequest(err)
      },
    })
  }

  getModuleStatus(modulo: ModuloPermissao): string {
    if (!modulo.acoes || modulo.acoes.length === 0) {
      return 'Sem ações'
    }

    const permitidas = modulo.acoes.filter(acao => acao.tem_permissao === 1).length
    const total = modulo.acoes.length

    if (permitidas === 0) {
      return 'Não Permitido'
    } else if (permitidas === total) {
      return 'Permitido'
    } else {
      return `Parcial (${permitidas}/${total})`
    }
  }

  isModuleFullyGranted(modulo: ModuloPermissao): boolean {
    return modulo.acoes.every(acao => acao.tem_permissao === 1)
  }
}
